import { render, staticRenderFns } from "./EditShopWeekendSettings.vue?vue&type=template&id=4c160890"
import script from "./EditShopWeekendSettings.vue?vue&type=script&lang=js"
export * from "./EditShopWeekendSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports